export default "__VITE_ASSET__CGHr9P0B__"